import { useState, useEffect } from "react";
import { CalendarIcon } from "@radix-ui/react-icons";
import { addDays, format } from "date-fns";
import { ptBR } from "date-fns/locale";

import { cn } from "../../lib/utils";
import { Button } from "./button";
import { Calendar } from "./calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from "./select";

export function DatePickerWithRange({ className, setDates }) {
  const [dateRange, setDateRange] = useState({ from: null, to: null });

  useEffect(() => {
    if (dateRange.from && dateRange.to) {
      
      setDates([dateRange.from, dateRange.to]);
    } else {
      setDates([]);
    }
  }, [dateRange, setDates]);

  const handlePresetSelect = (value) => {
    let startDate = null;
    let endDate = new Date();
    switch (value) {
      case "today":
        startDate = new Date();
        break;
      case "3daysago":
        startDate = addDays(new Date(), -3);
        break;
      case "1weekago":
        startDate = addDays(new Date(), -7);
        break;
      case "lastmonth":
        startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 1);
        break;
      case "lastyear":
        startDate = new Date();
        startDate.setFullYear(startDate.getFullYear() - 1);
        break;
      default:
        break;
    }
    setDateRange({ from: startDate, to: endDate });
  };

  const handleDateRangeSelect = (selectedRange) => {
   
    if(selectedRange?.from || selectedRange?.to) {

      setDateRange({ from: selectedRange?.from, to: selectedRange?.to });
      if(dateRange.from && dateRange.to) {
        setDates(dateRange);
      }
    } else {
      setDateRange([])
    }
   
    
  };

  return (
    <div className={cn("grid gap-2", className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant={"outline"}
            className={cn(
              "w-[300px] justify-start text-left font-normal",
              !dateRange.from && "text-muted-foreground"
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {dateRange.from ? (
              dateRange.to ? (
                <>
                  {format(dateRange.from, "LLL dd, y", { locale: ptBR })} -{" "}
                  {format(dateRange.to, "LLL dd, y", { locale: ptBR })}
                </>
              ) : (
                format(dateRange.from, "LLL dd, y")
              )
            ) : (
              <span>Periodo de tempo</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="flex w-auto flex-col space-y-2 p-2" align="start">
          <Select
            onValueChange={(value) => handlePresetSelect(value)}
          >
            <SelectTrigger>
              <SelectValue placeholder="Selecione um período predefinido" />
            </SelectTrigger>
            <SelectContent position="popper">
              <SelectItem value="today">Hoje</SelectItem>
              <SelectItem value="3daysago">3 dias atrás</SelectItem>
              <SelectItem value="1weekago">Uma semana atrás</SelectItem>
              <SelectItem value="lastmonth">Mês passado</SelectItem>
              <SelectItem value="lastyear">Ano passado</SelectItem>
            </SelectContent>
          </Select>
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={dateRange.from ? dateRange.from : new Date()}
            selected={dateRange}
            onSelect={handleDateRangeSelect}
            numberOfMonths={2}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}

